import { render, staticRenderFns } from "./PeopleAtTrial.vue?vue&type=template&id=38223273"
import script from "./PeopleAtTrial.vue?vue&type=script&lang=ts"
export * from "./PeopleAtTrial.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports